import request from '@/utils/request'

// 获取全部品牌列表
export function getBrandList(params) {
  return request({
    url: '/brand/listAll',
    method: 'get',
    params: params
  })
}
// 查看品牌
export function viewBrand(params) {
  return request({
    url: '/brand/' + params.id,
    method: 'get',
    params: params
  })
}
// 分页获取品牌列表
export function fetchList(params) {
  return request({
    url: '/brand/list',
    method: 'get',
    params: params
  })
}

export function createBrand(data) {
  return request({
    url: '/brand/create',
    method: 'post',
    data: data
  })
}

export function updateShowStatus(data) {
  return request({
    url: '/brand/update/showStatus',
    method: 'post',
    params: data
  })
}

export function updateFactoryStatus(data) {
  return request({
    url: '/brand/update/factoryStatus',
    method: 'post',
    params: data
  })
}

export function deleteBrand(id) {
  return request({
    url: '/brand/delete/' + id,
    method: 'get',
  })
}

export function getBrand(id) {
  return request({
    url: '/brand/' + id,
    method: 'get',
  })
}

export function updateBrand(id, data) {
  return request({
    url: '/brand/update/' + id,
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/brand.js